import React, { Component } from 'react';
import axios from 'axios';
import { apiEndpoints } from '../../config/config';
import { Title } from '../common/StyledComponents/Title';

class TnC extends Component {
  state = {
    tncData: null
  };
  componentWillMount = () => {
    window.scrollTo(0, 0);
  };

  componentDidMount = () => {
    let url = apiEndpoints.tnc;

    axios.get(url).then(response => {
      // console.log('response: ', response.data.pageData[0]);
      if (response.data.pageData && response.data.pageData.length) {
        this.setState({
          tncData: response.data.pageData[0]
        });
      }
    });
  };

  contentClickHandler = e => {
    const targetLink = e.target.closest('a');
    if (!targetLink) return;
    e.preventDefault();
    e.stopPropagation();
  };

  createMarkup = content => {
    return { __html: content };
  };

  render() {
    const { tncData } = this.state;

    return (
      <div
        className="Terms-and-Conditions pa3 bg-white w-100"
        style={{ maxWidth: '950px' }}
      >
        {tncData ? (
          <div>
            <Title
              className="tc b mb3"
              fontFamily="Nunito"
              fontSize="2.25rem"
              color="#222"
            >
              Terms and Conditions
            </Title>
            <Title
              fontFamily="Montserrat"
              fontSize="1rem"
              // fontstyle="italic"
              // letterSpacing="0.3px"
              color="#222"
              onClick={this.contentClickHandler}
              dangerouslySetInnerHTML={this.createMarkup(
                tncData.content.rendered
              )}
            />
          </div>
        ) : (
          <Title
            className="w-100 vh-100"
            fontFamily="Montserrat"
            fontSize="1.5rem"
            fontstyle="italic"
            // letterSpacing="0.3px"
            color="#222"
          >
            Loading..{' '}
          </Title>
        )}
      </div>
    );
  }
}

export default TnC;
